
import { defineComponent } from "vue";

export default defineComponent({
  name: "CloseHeader",
  props: {
    title: {
      type: String,
      required: false
    }
  }
});
